import LTR from "@brand-icons/ploom/ui-eye-close/ui-eye-close-ltr.svg";

import { iconFactory } from "../iconFactory";

export const UiEyeCloseIcon = iconFactory("UiEyeCloseIcon", LTR);
